import request from '../api-request';
import { PlanYear } from 'reports-tile/reports-tile.types';

export function getPlanYears(companyId: number) {
  return request<PlanYear[]>(`/api/companies/${companyId}/plan-years`);
}
